import React, { useEffect, useState } from "react";
import { ScheduleCSVObject } from "./ScheduleCSVObject";

interface Props {
  csvObject: ScheduleCSVObject;
  readerCallback?: (csvObject: ScheduleCSVObject) => void;
  deleteFile: (csvObject: ScheduleCSVObject) => void;
  onParseError?: (csvObject: ScheduleCSVObject) => void;
}

export function ImportScheduleFile(props: Props): JSX.Element {
  const [loading, setLoading] = useState<number>(0);

  const { csvObject, readerCallback, onParseError } = props;

  const handleDeleteFile = (): void => {
    props.deleteFile(props.csvObject);
  };

  // Initialize file processing on mount
  useEffect(() => {
    if (!csvObject.processed) {
      csvObject.parseFileContents(
        (progress: number) => {
          if (progress < 100) {
            setLoading(progress);
          }
        },
        (processedCsvObject: ScheduleCSVObject) => {
          setLoading(100);
          readerCallback?.(processedCsvObject);
        },
        (errorCsvObject: ScheduleCSVObject) => {
          setLoading(100);
          onParseError?.(errorCsvObject);
        }
      );
    } else if (csvObject.getHasError()) {
      setLoading(100);
      onParseError?.(csvObject);
    } else if (!csvObject.getHasError()) {
      setLoading(100);
    }
  }, [csvObject, readerCallback, onParseError]);

  const file = props.csvObject.getFile();

  if (loading !== 100) {
    return (
      <div className="file">
        <div className="fileName">{file.name}</div>
        <div className="fileInfo">
          <div className="loadingEntries">Loading ({loading.toFixed(0)}%)</div>
        </div>
      </div>
    );
  }

  const uniqueEntries = props.csvObject.getUniqueEntries();

  return (
    <div className="file">
      <div className="fileName">{file.name}</div>
      <div className="fileInfo">
        <div className="uniqueEntries">
          {uniqueEntries.classrooms} <i className="fa fa-users" title="Classrooms" aria-hidden="true" />
        </div>
        <div className="uniqueEntries">
          {uniqueEntries.periods} <i className="fa-solid fa-clock" title="Periods" aria-hidden="true" />
        </div>
        <div className="deleteButton" onClick={handleDeleteFile}>
          <i className="fa fa-times" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
